import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ProfileGuard } from './guards/profile.guard';
import { TrainerGuard } from './guards/trainer.guard';

const routes: Routes = [
  {
    path: 'account/login',
    loadChildren: () =>
      import('./pages/registration/registration.module').then(
        (m) => m.RegistrationPageModule
      ),
  },
  {
    path: 'account/password-reset',
    loadChildren: () =>
      import('./pages/password-reset/password-reset.module').then(
        (m) => m.PasswordResetPageModule
      ),
  },
  {
    path: 'account/preferences/edit',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/user-preferences/user-preferences.module').then(
        (m) => m.UserPreferencesPageModule
      ),
  },
  {
    path: 'werder-bremen/rate/:playerId',
    canActivate: [TrainerGuard],
    loadChildren: () =>
      import('./pages/werder-bremen-videos/werder-bremen-videos.module').then(
        (m) => m.WerderBremenVideosPageModule
      ),
  },
  {
    path: 'user/:userId',
    canActivate: [ProfileGuard],
    loadChildren: () =>
      import('./pages/user/user.module').then((m) => m.UserPageModule),
  },
  {
    path: 'app-install',
    loadChildren: () =>
      import('./pages/app-install/app-install.module').then(
        (m) => m.AppInstallPageModule
      ),
  },
  {
    path: 'parental-consent',
    loadChildren: () =>
      import('./pages/parental-consent/parental-consent.module').then(
        (m) => m.ParentalConsentPageModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: 'werder-bremen-videos',
    loadChildren: () =>
      import('./pages/werder-bremen-videos/werder-bremen-videos.module').then(
        (m) => m.WerderBremenVideosPageModule
      ),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
